import { AxiosResponse } from "axios";

type NavigatorIncludesMS = Navigator & { msSaveBlob?: (blob: Blob, filename?: string) => void };

export function downloadFile(url: string, filename?: string): void {
    const link = document.createElement('a');

    if (typeof link.download === 'undefined') {
        window.location.href = url;
    } else {
        link.href = url;
        link.download = filename ?? "true";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}

function checkIsTrustedBlobDownloadUrl(url: string): boolean {
    return url.startsWith('blob:' + window.location.origin);
}

export function downloadBlobFile(blob: Blob, filename?: string) {
    const navigator = window.navigator as NavigatorIncludesMS;

    if (navigator.msSaveBlob && typeof navigator.msSaveBlob !== 'undefined') {
        navigator.msSaveBlob(blob, filename);
    } else {
        let URL = window.URL || window.webkitURL;
        const downloadUrl = URL.createObjectURL(blob);

        if (checkIsTrustedBlobDownloadUrl(downloadUrl)) {
            if (filename) {
                downloadFile(downloadUrl, filename);
            } else {
                window.location.href = downloadUrl;
            }

        }

        setTimeout(() => {
            URL.revokeObjectURL(downloadUrl);
        }, 100);
    }
}

export const getFilenameFromContentDisposition = (disposition: string | null): string => {
    let filename = "";
    if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = new RegExp(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        const matches = filenameRegex.exec(disposition);
        filename = matches?.[1].replace(/['"]/g, '') ?? `File Export ${new Date()}`;
    }

    return filename;
}

export async function downloadFileFromBlobResponse(response: AxiosResponse<Blob>) {
    const fileName = getFilenameFromContentDisposition(response?.headers?.['content-disposition']);
    const blob = response?.data ? new Blob([response.data], { type: response?.headers?.['content-type'] }) : null;

    return blob && downloadBlobFile(blob, fileName);
}
